import { httpApi } from '@api/http.api.ts';
import type { CompletionMethod } from '@routes/profile-bar/___pages___/my-results/___shared___/constants.ts';

export interface CertificateDataResponse {
    resultId: number;
    certificateContentId: string | null;
    pathwayTitle: string;
    pathwayVersion: string;
    userFullName: string;
    certificateVersion: string;
    dateOfBirth: string;
    userNationality: string;
    createdAtUTC: string;
    completionMethod: CompletionMethod;
    learningObjectives: string[];
    additionalCertificateText: string | null;
    qrCodeUrl: string | null;
}

export const getApiCertificateData = (resultId: number): Promise<CertificateDataResponse> =>
    httpApi.get<CertificateDataResponse>(`users/results/certificate-data/${resultId}`).then(({ data }) => data);

export const postApiCertificate = (resultId: number, certificateFile: Blob, fileName: string): Promise<void> => {
    const formData = new FormData();
    formData.append('certificateFile', certificateFile, fileName);

    return httpApi.post<void>(`users/results/${resultId}/certificate`, formData).then(({ data }) => data);
};
